import { render, staticRenderFns } from "./ListClass.vue?vue&type=template&id=5aaee419&scoped=true"
import script from "./ListClass.vue?vue&type=script&lang=js"
export * from "./ListClass.vue?vue&type=script&lang=js"
import style0 from "./ListClass.vue?vue&type=style&index=0&id=5aaee419&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaee419",
  null
  
)

export default component.exports